import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import ActionButton from 'components/action-button';
import LoyaltyPointsIcon from 'components/icons/loyalty-points-icon';
import Link from 'components/link';
import Picture from 'components/picture';
import SanityBlockRenderer from 'components/sanity-block-renderer';
import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

import { LoyaltyLoader } from '../loyalty-loader';

export const LoadingAnimation = LoyaltyLoader.withConfig({
  height: '50%',
  width: '50%',
});

export const MainImage = Picture.withConfig({
  alignSelf: 'center',
  objectFitContain: true,
});

const TextBlock = SanityBlockRenderer.withConfig({
  textProps: {
    fontSize: 'md',
    lineHeight: 'md',
  },
  linkProps: {
    fontSize: 'md',
    lineHeight: 'md',
    underline: true,
  },
});

export const Text = TextBlock.withConfig({
  marginTop: 0,
  textProps: {
    textAlign: 'center',
  },
});

export const InstructionDateText = TextBlock;

const styles = StyleSheet.create({
  title: {
    margin: 0,
    marginTop: spacing.$6,
  },
  transactionInputFormContainer: {
    flexDirection: 'row',
    gap: spacing.$2,
    justifyContent: 'center',
  },
  transactionDateInputFormContainer: {
    gap: spacing.$2,
    marginBottom: spacing.$10,
    marginTop: spacing.$6,
  },
  earnedPointsWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: spacing.$6,
    marginTop: spacing.$2,
  },
  claimsPointContent: {
    margin: spacing.$1,
  },
});

export const Title = withTypography({
  variant: 'headerTwo',
  fontSize: '2xl',
  lineHeight: 'lg',
  textAlign: 'center',
  focusable: true,
  style: styles.title,
});

export const Button = makeUclComponent(ActionButton).withConfig({
  paddingTop: spacing.$2_5,
  paddingBottom: spacing.$2_5,
  paddingX: '$12',
  marginX: { base: 0, md: '$5' },
});

export const StyledLink = makeUclComponent(Link).withConfig({
  alignSelf: 'center',
  color: primitive.$fieryRed,
  isUnderlined: true,
  isInline: true,
});

export const TransactionInputFormContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.transactionInputFormContainer, style] });

export const TransactionDateInputFormContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.transactionDateInputFormContainer, style] });

export const EarnedPointsWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.earnedPointsWrapper, style] });

export const EarnedPointsText = withTypography({
  fontFamily: 'heading',
  fontSize: 'lg',
});

export const StyledLoyaltyPointsIcon = LoyaltyPointsIcon.withConfig({
  width: '$8',
  height: '$8',
  marginTop: 0,
  marginRight: spacing.$1_5,
  marginBottom: 0,
  marginLeft: '$2',
});

export const ClaimsPointContent = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.claimsPointContent, style] });
